module.exports = __webpack_public_path__ + "img/content1-1.0b39213c.webp";